import React, { useEffect, useState } from "react";
import BatchStudentAttendanceListing from "./BatchStudentAttendanceListing";
import { columnTypes } from "src/components/UI/atoms/ATMTable/ATMTable";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "src/redux/store";
import {
  setPage,
  setRowsPerPage,
  setSearchValue,
  setIsTableLoading,
  setItems,
  setTotalItems,
} from "src/redux/slices/BatchStudentAttendanceSlice";
import { useGetAllStudentOfBatchQuery } from "src/services/BatchServices";
import { useUpdateAttendanceMutation } from "src/services/BatchServices";
import { showToast } from "src/utils/showToaster";
import { useParams } from "react-router-dom";
import ATMLoadingButton from "src/components/UI/atoms/ATMLoadingButton/ATMLoadingButton";
import { useGetAllStudentAttendanceCountQuery } from "src/services/StudentServices";
import moment from "moment";

type Props = {};

const BatchStudentAttendanceListingWrapper = (props: Props) => {
  const dispatch = useDispatch();
  const { batchId } = useParams();
  const [studentAttendanceCount, setStudentAttendanceCount] = useState<any>({});
  const [rowId, setRowId] = useState<any>("");

  const { items, totalItems, page, rowsPerPage, searchValue, isTableLoading } =
    useSelector((state: RootState) => state.batchesattendance);
  
  //API
  const { data, isLoading, isFetching } = useGetAllStudentOfBatchQuery({
    limit: rowsPerPage,
    searchValue: searchValue,
    params: ["studentName"],
    page: page,
    filterBy: [
      {
        fieldName: "batchId",
        value: batchId,
      },
    ],
    dateFilter: {
      startDate: moment().format("YYYY-MM-DD"),
      endDate: moment().format("YYYY-MM-DD"),
    },
    orderBy: "createdAt",
    orderByValue: -1,
    isPaginationRequired: false,
  });

  const {
    data: studentCount,
    isLoading: studentCountIsLoading,
    isFetching: studentCountIsFetching,
  } = useGetAllStudentAttendanceCountQuery({
    filterBy: [{ fieldName: "batchId", value: batchId }],
    dateFilter: {
      startDate: moment().format("YYYY-MM-DD"),
      endDate: moment().format("YYYY-MM-DD"),
    },
  });
  const [updateAttenDance, updateAttenDanceInfo] =
    useUpdateAttendanceMutation();

  //UseEffect

  useEffect(() => {
    if (!studentCountIsLoading && !studentCountIsFetching) {
      setStudentAttendanceCount(studentCount?.data?.[0]);
    }
  }, [studentCountIsLoading, studentCountIsFetching, studentCount]);
  useEffect(() => {
    if (isLoading || isFetching) {
      dispatch(setIsTableLoading(true));
    } else {
      dispatch(setItems(data?.data || []));
      dispatch(setTotalItems(data?.totalItem || 0));
      dispatch(setIsTableLoading(false));
      dispatch(setRowsPerPage(data?.pageSize || 0));
      dispatch(setPage(data?.currentPage || 0));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, isLoading, isFetching]);

  const handleAttendance = (Id: string, status: string) => {
    const attendanceList = [...items];
    const attendanceIndex = attendanceList?.findIndex((ele) => ele._id === Id);
    if (attendanceIndex !== -1) {
      attendanceList[attendanceIndex] = {
        ...attendanceList[attendanceIndex],
        isPresent: status,
      };
    }
    dispatch(setItems(attendanceList));
  };

  const handleCameOnTime = (Id: string, status: string) => {
    const attendanceList = [...items];
    const attendanceIndex = attendanceList?.findIndex((ele) => ele._id === Id);
    if (attendanceIndex !== -1) {
      attendanceList[attendanceIndex] = {
        ...attendanceList[attendanceIndex],
        cameOnTime: status,
      };
    }
    dispatch(setItems(attendanceList));
  };

  useEffect(() => {
    const handleKeyPress = (event: any) => {
      const attendanceList = [...items];
      const attendanceIndex = attendanceList?.findIndex(
        (ele) => ele?._id === rowId
      );    
      if (event.key === "Tab") {
        event.preventDefault(); // Prevent the default behavior of the Tab key
         const nextIndex= items?.length === attendanceIndex ? 0 : attendanceIndex + 1 
        setRowId((prevIndex:any) => {    
          const nextId =  attendanceList[nextIndex]?._id;
          return  nextId
        });
      }
      
      if (event.key === "a" || event.key === "A") {
        event.preventDefault(); // Prevent the default behavior of the 'A' key
        if (rowId !== null) {
          handleAttendance(rowId, "A");
        }
      } else if (event.key === "p" || event.key === "P") {
        event.preventDefault(); // Prevent the default behavior of the 'A' key
        if (rowId !== null) {
          handleAttendance(rowId, "P");
        }
      } else if (event.key === "t" || event.key === "T") {
        event.preventDefault(); // Prevent the default behavior of the 'A' key
        if (
          rowId !== null &&
          attendanceList[attendanceIndex]?.isPresent === "P"
        ) {
          handleCameOnTime(rowId, "YES");
        }
      } else if (event.key === "l" || event.key === "L") {
        event.preventDefault(); // Prevent the default behavior of the 'A' key
        if (
          rowId !== null &&
          attendanceList[attendanceIndex]?.isPresent === "P"
        ) {
          handleCameOnTime(rowId, "NO");
        }
      }
    };

    document.addEventListener("keydown", handleKeyPress);

    return () => {
      document.removeEventListener("keydown", handleKeyPress);
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rowId, items]); 


  const columns: columnTypes[] = [
    {
      field: "studentName",
      extraClasses: "py-1",
      headerName: "Name",
      flex: "flex-[1_1_0%] ",
      align:'center'
    },
    // {
    //   field: "mobileNumber",
    //   headerName: "Mobile Number",
    //   flex: "flex-[1_1_0%]",
    // },
    {
      field: "isPresent",
      headerName: "Is-Present",
      flex: "flex-[2_2_0%]",
      extraClasses: "justify-center py-1",
      renderCell: (row: any) => (
        <div className={rowId === row?._id ? 'bg-gray-100 px-6 py-[2px]' :''}>
          <div className="flex gap-2 items-center">
            <div
              onClick={() => {
                handleAttendance(row?._id, "P");
              }}
              className={`border rounded-full text-base  px-[7px] py-[2px] cursor-pointer ${
                row?.isPresent === "P"
                  ? "bg-green-500 text-white font-medium"
                  : "bg-slate-100"
              }`}
            >
              Present
            </div>
            <div
              onClick={() => {
                handleAttendance(row?._id, "A");
              }}
              className={`border rounded-full text-base  px-[7px] py-[2px] cursor-pointer ${
                row?.isPresent === "A"
                  ? "bg-red-700 text-white font-medium"
                  : "bg-slate-100"
              }`}
            >
              Absent
            </div>
          </div>
        </div>
      ),
    },
    {
      field: "timing",
      headerName: "Came on time",
      flex: "flex-[1.5_1.5_0%]",
      extraClasses: "justify-center",
      renderCell: (row: any) => (
        <div className={rowId === row?._id ? 'bg-gray-100 px-6 py-1' :''}>
          {row?.isPresent !== "A" && (
            <div className="flex gap-2 items-center">
              <div
                onClick={() => {
                  handleCameOnTime(row?._id, "YES");
                }}
                className={`border rounded-full text-base  px-[8px] py-[2px] cursor-pointer ${
                  row?.cameOnTime === "YES"
                    ? "bg-green-500 text-white font-medium"
                    : "bg-slate-100"
                }`}
              >
                Yes
              </div>
              <div
                onClick={() => {
                  handleCameOnTime(row?._id, "NO");
                }}
                className={`border rounded-full text-base  px-[8px] py-[2px] cursor-pointer ${
                  row?.cameOnTime === "NO"
                    ? "bg-red-700 text-white font-medium"
                    : "bg-slate-100"
                }`}
              >
                No
              </div>
            </div>
          )}
        </div>
      ),
    },
  ];

  const handleSubmit = () => {
    const newArray = items.map((ele: any) => {
      return {
        Id: ele._id,
        presentStatus: ele.isPresent,
        cameOnTimeStatus: ele.cameOnTime || "NA",
      };
    });
    updateAttenDance({
      studentInfo: newArray,
    }).then((res: any) => {
      if (res?.error) {
        showToast("error", res?.error?.data?.message);
      } else {
        if (res?.data?.status) {
          showToast("success", res?.data?.message);
        } else {
          showToast("error", res?.data?.message);
        }
      }
    });
  };

  return (
    <div>
      <BatchStudentAttendanceListing
        columns={columns}
        rows={items}
        setRowId={setRowId}
        studentAttendanceCount={studentAttendanceCount}
        paginationProps={{
          isTableLoading,
          totalItems,
          page,
          rowsPerPage,
          searchValue,
          setPage: (newPage) => dispatch(setPage(newPage)),
          setRowsPerPage: (newRowsPerPage) =>
            dispatch(setRowsPerPage(newRowsPerPage)),
          setSearchValue: (newValue) => dispatch(setSearchValue(newValue)),
        }}
      />
      <div className="flex justify-end mr-4">
        <div className="w-[150px]">
          <ATMLoadingButton
            onClick={() => {
              handleSubmit();
            }}
            isLoading={updateAttenDanceInfo?.isLoading}
          >
            Save
          </ATMLoadingButton>
        </div>
      </div>
    </div>
  );
};

export default BatchStudentAttendanceListingWrapper;
